<a [routerLink]="link" class="text-secondary">
  <i *ngIf="type === 'breadcrumb'" class="fal fa-long-arrow-left me-1"></i>
  <ng-content></ng-content>
</a>
